function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("metadata", null, "Created by potrace 1.15, written by Peter Selinger 2001-2017");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 200) scale(.1 -.1)"
}, React.createElement("path", {
  d: "m227 1873c-4-3-7-316-7-694 0-678 0-688 20-699 14-8 26-8 40 0 20 11 20 21 20 665v655h360 359l3-137 3-138 138-3 137-3v-274c0-264 1-275 20-285 14-8 26-8 40 0 19 10 20 21 20 318v307l-295 295h-426c-234 0-429-3-432-7z"
}), React.createElement("path", {
  d: "m531 1310-56-59-24 19c-29 25-36 25-61 0-28-28-26-34 21-85 58-63 83-61 145 12 61 71 94 115 94 125 0 12-39 48-52 48-6 0-37-27-67-60z"
}), React.createElement("path", {
  d: "m671 1234c-23-17-27-44-9-62 9-9 85-12 280-12 257 0 268 1 278 20 13 23 0 54-26 64-10 4-126 6-259 6-198-1-246-4-264-16z"
}), React.createElement("path", {
  d: "m531 1010-56-59-24 19c-29 25-36 25-61 0-28-28-26-34 21-85 58-63 83-61 145 12 61 71 94 115 94 125 0 12-39 48-52 48-6 0-37-27-67-60z"
}), React.createElement("path", {
  d: "m669 932c-22-15-25-42-7-60 9-9 85-12 280-12 257 0 268 1 278 20 8 14 8 26 0 40-10 18-24 19-272 22-202 2-265 0-279-10z"
}), React.createElement("path", {
  d: "m1259 857c-95-40-158-96-199-178l-21-40-180 1c-186 2-209-3-209-39 0-37 19-41 196-41h172l4-80 3-80h-393c-406 1-422-1-422-39 0-40 9-41 435-41h410l35-47c45-61 105-106 177-133 83-31 214-26 295 12 79 37 142 98 181 177 30 61 32 72 32 171s-2 110-32 171c-39 79-102 140-181 177-47 22-74 27-152 30-81 2-103-1-151-21zm247-84c66-22 145-101 167-167 39-114 14-231-67-312-115-115-297-115-412 0-115 116-115 297 1 412 30 30 68 57 95 67 60 21 155 21 216 0z"
}), React.createElement("path", {
  d: "m1378 739c-10-5-18-21-18-35 0-17-8-27-24-34-36-13-56-49-56-101 0-57 25-86 97-110 57-19 72-49 24-49-20 0-34 7-41 19-23 43-90 28-90-20 0-19 63-89 80-89 6 0 10-11 10-25 0-31 32-50 60-35 12 6 20 21 20 35 0 17 9 29 30 40 38 20 50 43 50 98s-26 84-97 108c-28 9-49 23-51 32-5 27 47 21 74-8 28-30 35-31 65-6 20 16 22 23 14 47-6 16-27 40-48 53-25 17-37 32-37 47 0 13-9 28-19 34-23 12-22 12-43-1z"
}), React.createElement("path", {
  d: "m531 710-56-59-24 19c-29 25-36 25-61 0-28-28-26-34 21-85 58-63 83-61 145 12 61 71 94 115 94 125 0 12-39 48-52 48-6 0-37-27-67-60z"
}));

var SvgParcelMaster = function SvgParcelMaster(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgParcelMaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parcel-master.9373c150.svg";
export { ForwardRef as ReactComponent };